import { Component, OnInit } from '@angular/core';
import { ProductService } from '../../services/product.service';
import { SharedService } from '../../services/core/shared.service';
import { Router } from '@angular/router';
import * as _ from "lodash";

@Component({
  selector: 'app-inventory',
  templateUrl: './inventory.component.html',
  styleUrls: ['./inventory.component.css']
})
export class InventoryComponent implements OnInit {
  p:any = [];
  ps:any = [];
  pieces:number = 0;

  constructor(
    private sharedService:SharedService,    
    private router: Router,
    private productService:ProductService) { }

  ngOnInit() {
    this.productService.readInventory().then(res=>{    
      this.p = res; 
      this.ps = res; 
      this.pieces = this.calculatePieces();    
    },err=>{console.error(err);}).catch(err=>{console.error(err);});

    this.sharedService.sharedData.subscribe(data => {
      if(data && data.name === 'searchText'){
      if (data && data.value && data.value != '') {        
        //retore the orinal list
        this.p = this.ps;
        var filtered = _.map(this.p, function(o) {
          if (
            o.name.toLowerCase().indexOf(data.value.toLowerCase()) != -1 ||
            o.brand.toLowerCase().indexOf(data.value.toLowerCase()) != -1)
           return o;
        });
        // Remove undefines from the array
        this.p = _.without(filtered, undefined)
        //console.log(this.p);
      }
      else{
        this.p = this.ps;
      }
      this.pieces = this.calculatePieces();
    }
    });
  }

  goDetails(p){
    this.sharedService.nextData({"name":"details","value":p});
    this.router.navigate(['details',p.id]);
  }

  private calculatePieces(){
    let ipices = 0;
    this.p.forEach(e =>{
      ipices += e.pieces;      
    });
    return ipices;
  }

  formatUrl(url){
    if(url && url != ""){
      return url.replace('.jpg','_253.jpg');
    }
    return "https://dummyimage.com/400.png/aaa/fff"
  }
  displayMoney(amount) {
    return amount ? "$" + amount : "";
  }

}



// WEBPACK FOOTER //
// /Users/eduar.doramirez/developer/code/edd/ceramicamx/web/cmx-catalog/src/app/pages/inventory/inventory.component.ts